import { create } from 'zustand';

/**
 * Per-widget runtime measurements that the dashboard layout reads back
 * to size the grid cell. Kept separate from `widgets-store` because
 * these are derived from query results (transient, not persisted) and
 * change as data reloads — co-locating with the config store would
 * blur the persistence boundary.
 *
 * Today the only consumer is `compare-table`: the widget publishes
 * `max(winners.length, losers.length)` after each query, and
 * `DashboardGrid` adds the matching extra rows so the cell hugs the
 * actual data instead of the `limit` ceiling
 * (item: tablonun veri sayısına göre minimum yükseklikte olması).
 */
type State = {
  /** widgetId → rendered row count (winners or losers, whichever is larger). */
  compareTableRows: Record<string, number>;
  setCompareTableRows: (widgetId: string, rows: number) => void;
  clearCompareTableRows: (widgetId: string) => void;
};

export const useWidgetRuntimeStore = create<State>((set) => ({
  compareTableRows: {},
  setCompareTableRows: (widgetId, rows) =>
    set((s) => {
      // Avoid spurious renders when the row count didn't actually change.
      if (s.compareTableRows[widgetId] === rows) return s;
      return {
        compareTableRows: { ...s.compareTableRows, [widgetId]: rows },
      };
    }),
  clearCompareTableRows: (widgetId) =>
    set((s) => {
      if (!(widgetId in s.compareTableRows)) return s;
      const next = { ...s.compareTableRows };
      delete next[widgetId];
      return { compareTableRows: next };
    }),
}));